import { render, staticRenderFns } from "./LayoutCartPreview.vue?vue&type=template&id=065b054a&scoped=true"
import script from "./LayoutCartPreview.vue?vue&type=script&lang=js"
export * from "./LayoutCartPreview.vue?vue&type=script&lang=js"
import style0 from "./LayoutCartPreview.vue?vue&type=style&index=0&id=065b054a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b054a",
  null
  
)

export default component.exports